// Manual names retain acronyms and mixed case; intake has its own formatter.
export function formatManualClientName(value) {
  return String(value || "")
    .replace(/(^|[\s'’.-])(\p{L})/gu, (_, prefix, letter) => `${prefix}${letter.toUpperCase()}`)
    .trim();
}
